import template from './tooltip.html'

let component = {
  restrict: 'E',
  bindings: {
    text: '<',
    name: '<',
    show: '='
  },
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/tooltip/tooltip.component.js